import { RecurrenceType } from "@clockwise/schema";
import EventCard from "@clockwise/web-commons/src/components/EventCard";
import classNames from "classnames";
import { filter, isEmpty } from "lodash";
import React from "react";
import { FlexMeeting } from "../utils/suggestion-utils";
import { FlexMeeingCardColumn } from "./FlexMeetingCardColumn";
const mapEventToEventCard = (oneOnOne: FlexMeeting) => (
  <EventCard
    conflicted={oneOnOne.conflicted}
    editable={oneOnOne.editable}
    eventId={oneOnOne.id}
    flexible={oneOnOne.flexible}
    key={oneOnOne.id}
    recurrence={oneOnOne.recurrenceText}
    title={oneOnOne.title}
    restricted={false}
  />
);

export const FlexMeetingColumns = ({
  flexMeetings,
  updateFlexibility,
}: {
  flexMeetings: FlexMeeting[];
  updateFlexibility: (eventId: string, isFlexible: boolean) => void;
}) => {
  const weeklyOneOnOnes = filter<FlexMeeting>(flexMeetings, { recurrence: RecurrenceType.Weekly });
  const biweeklyOneOnOnes = filter<FlexMeeting>(flexMeetings, {
    recurrence: RecurrenceType.Fortnightly,
  });
  const infrequentOneOnOnes = filter<FlexMeeting>(
    flexMeetings,
    ({ recurrence }) =>
      recurrence !== RecurrenceType.Weekly && recurrence !== RecurrenceType.Fortnightly,
  );

  const getColumnCount = () => {
    let count = 0;
    if (!isEmpty(weeklyOneOnOnes)) {
      count = count + 1;
    }
    if (!isEmpty(biweeklyOneOnOnes)) {
      count = count + 1;
    }
    if (!isEmpty(infrequentOneOnOnes)) {
      count = count + 1;
    }
    return count;
  };

  const renderOneColumn = getColumnCount() === 1;

  return (
    <div
      className={classNames(
        "cw-w-full cw-bg-default md:cw-bg-brand cw-h-full cw-rounded-lg",
        {
          "lg:cw-max-w-[950px]": !renderOneColumn,
          "md:cw-max-w-[500px] lg:cw-max-w-[500px]": renderOneColumn,
        },
        "cw-overflow-y-scroll cw-pb-16 md:cw-pb-0 cw-mt-4 cw-border-0 md:cw-border cw-border-solid cw-border-brand-pressed",
      )}
    >
      <div className="cw-flex cw-flex-col md:cw-flex-row cw-p-4 cw-w-full cw-justify-center md:cw-max-h-[450px]">
        <FlexMeeingCardColumn
          heading={renderOneColumn ? undefined : "WEEKLY"}
          emptyMessage="No weekly one-on-ones"
          onFlexibilityChange={updateFlexibility}
        >
          {weeklyOneOnOnes.map((oneOnOne) => mapEventToEventCard(oneOnOne))}
        </FlexMeeingCardColumn>

        <FlexMeeingCardColumn
          heading={renderOneColumn ? undefined : "BIWEEKLY"}
          emptyMessage="No bi-weekly one-on-ones"
          onFlexibilityChange={updateFlexibility}
        >
          {biweeklyOneOnOnes.map((oneOnOne) => mapEventToEventCard(oneOnOne))}
        </FlexMeeingCardColumn>
        <FlexMeeingCardColumn
          heading={renderOneColumn ? undefined : "LESS FREQUENT"}
          emptyMessage="No less frequent one-on-ones"
          onFlexibilityChange={updateFlexibility}
        >
          {infrequentOneOnOnes.map((oneOnOne) => mapEventToEventCard(oneOnOne))}
        </FlexMeeingCardColumn>
      </div>
    </div>
  );
};
